//Principais
import { formatDate, registerLocaleData } from '@angular/common';
import myLocalePt from '@angular/common/locales/pt';
import { Component, inject, OnInit, signal, TemplateRef, ViewChild  } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgSelectConfig } from "@ng-select/ng-select";
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { PlanoContingencia } from "src/app/shared/models/plano-contingencia/plano-contingencia";
import { PlanoMelhoria } from "src/app/shared/models/plano-melhoria/planoMelhoria";
import { NaoOcorrencia } from "src/app/shared/models/nao-ocorrencia/NaoOcorrencia";
import { Consolidado } from "src/app/shared/models/relatorio/Consolidado";
import { ListarCalendario } from "src/app/shared/models/relatorio/listar-calendario";


//Services
import { RouterLink } from '@angular/router';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from "components/base/base.component";
import { CalendarioComponent } from 'components/calendario/calendario.component';
import { ModalAutorizacaoComponent } from 'components/modal-autorizacao-dados/modal-autorizacao.component';
import { ModalNotificacoesAlertComponent } from 'components/modal-notificacoes-alert/modal-notificacoes-alert.component';
import { TresPontosComponent } from 'components/tres-pontos/tres-pontos.component';
import { VisibilityManagerComponent } from 'components/visibility-manager/visibility-manager.component';
import { lastValueFrom } from "rxjs";
import { AlunosRecorrentes } from "src/app/shared/models/aluno/AlunosRecorrentes";
import { ListarEncaminhados } from "src/app/shared/models/chamados/listar-encaminhados";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { PlanoStatus } from 'src/app/shared/enums/PlanoContingencia/PlanoStatus';
import { StatusPlanoMelhoria } from 'src/app/shared/enums/PlanoMelhoria/StatusPlanoMelhoria';
import { FiltroPadrao } from "src/app/shared/models/filtro-padrao/filtroPadrao";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { PlanoContingenciaService } from "src/app/shared/services/plano-contingencia.service";
import { PlanoMelhoriaService } from "src/app/shared/services/plano-melhoria.service";
import { EncaminhamentoService } from "src/app/shared/services/encaminhamento.service";
import { NaoOcorrenciaService } from "src/app/shared/services/nao-ocorrencia.service";
import { RelatorioService } from "src/app/shared/services/relatorio.service";
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { ParametroPeriodoService } from 'src/app/shared/services/parametro-periodo.service';
import { NotificacaoService } from 'src/app/shared/services/notificacao.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports, RouterLink,
    TresPontosComponent, NgbPagination, ModalAutorizacaoComponent, ModalNotificacoesAlertComponent, VisibilityManagerComponent, CalendarioComponent]
})

export class HomeComponent extends BaseComponent implements OnInit {
  //Injeção
  config = inject(NgSelectConfig);
  chamadoService = inject(ChamadoService);
  planoContingenciaService = inject(PlanoContingenciaService);
  planoMelhoriaService = inject(PlanoMelhoriaService);
  encaminhamento = inject(EncaminhamentoService);
  relatorioService = inject(RelatorioService);
  naoOcorrenciaService = inject(NaoOcorrenciaService);
  ParametroPeriodoService = inject(ParametroPeriodoService);
  notificacaoService = inject(NotificacaoService);
  public page = 1;
  public totalRegisterCount = 0;

  public get Psicologo() { return (this.atribuicoesLogin == undefined && this.userLogado?.flPsicologo); }
  public get CoordenadorPsicologo() { return this.userLogado?.DadosUsuario?.filter(s => s.CodigoPerfil == 1632).length }
  public get codigoPerfilAtual(): number {
    return Number(this.userLogado?.codigoPerfil ?? this.userLogado?.DadosUsuario?.[0]?.CodigoPerfil ?? 0);
  }
  public currentDate: string;
  public mesCalendario: number;
  public anoCalendario: number;
  public daysInMonth: { date: Date, isWeekend: boolean, isHoliday: boolean }[] = [];
  public qtdeCaracteresDescricao: number = 0;
  public showModalAdicionarChamado = false;
  public lstDiretorias: Diretoria[] = [];
  public lstEscolas: Escola[] = [];

  filtrosCalendarios = signal<FiltroPadrao | undefined>(undefined);
  constructor() {
    super();
  }

  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  public showModal = false;
  public submittedModal = false;
  public tituloModal = '';
  public descricaoExclusao = '';
  public descricaoNaoOcorrencia = '';
  public dataOcorrenciaNaoOcorrencia = new Date();
  public chamadoARemover = 0;

  // FILTROS
  public gravidades = [{ id: 1, name: 'Amarelo' }, { id: 2, name: 'Vermelho' }];
  public lstChamados: ListarChamados[] = [];
  public lstAllChamados: ListarChamados[] = [];
  public alunosRecorrentes: AlunosRecorrentes[] = [];
  public listaDias: ListarCalendario[] = [];
  public chamadoFiltrado: number = 0;
  public formHomeNaoOcorrencia!: FormGroup;

  public get formNaoOco() { return this.formHomeNaoOcorrencia.controls; }

  // MODAL
  public submitted = false;
  public showPesquisa = false;
  public showModalExcluirChamado = false;
  public showModalNotificacao = false;
  public showModalCalendarioOcorrencia = false;
  public showModalCadastraNaoOcorrencia = false;
  public FlagSemPlanoContingencia = false;
  public FlagSemPlanoMelhoria = false;
  public codigoChamadoSelected: number;
  public codigoEnvolvidoSelected: number;
  public formModal!: FormGroup;
  public get modalForm() { return this.formModal.controls; }

  //MODAL ENCERRAMENTO CHAMADO ENVOLVIDO
  public ShowModalEncerrarChamado = false;
  public descricaoEncerrarChamado = "";
  public chamadoEncerrarChamado = 0;

  //MODAL CONCLUIR CHAMADO
  public chamadoSeleccionado: ListarChamados;
  public item: ListarChamados;
  public showModalConcluirChamado = false;
  public descricaoConcluir = "";
  public chamadoAConcluir = 0;
  public chamadoHistorico: ListarChamados;

  //Modal notificação
  public lstChamadosAtrasados: ListarChamados[] = [];
  public lstPlanosContingenciaPendentes: PlanoContingencia[] = [];
  public lstPlanosMelhoriaPendentes: PlanoMelhoria[] = [];
  public lstPlanosContingenciaAjustes: PlanoContingencia[] = [];
  public lstPlanosMelhoriaAjustes: PlanoMelhoria[] = [];
  public lstPlanosContingenciaAguardandoSupervisor: PlanoContingencia[] = [];
  public lstPlanosMelhoriaAguardandoSupervisor: PlanoMelhoria[] = [];
  public mensagemNotificacao: string[] = [];
  /** Pendências de validação (API unificada — Supervisor / PEC). */
  public contagemPlanoContingenciaValidacao = 0;
  public contagemPmceValidacao = 0;

  public dentroDoPeriodoContingencia: boolean = false;
  public dentroDoPeriodoMelhoria: boolean = false;
  public dtInicioContingencia: Date;
  public dtFimContingencia: Date;
  public anoMelhoria: number;

  public async ngOnInit() {

    this.formHomeNaoOcorrencia = new FormGroup({
      dsChamado: new FormControl(null)
    });

    const DateObj = new Date();
    this.anoCalendario = DateObj.getFullYear();
    this.mesCalendario = DateObj.getMonth();

    if(this.atribuicoesLogin.CodigoPerfil == 112){
       this.router.navigate(['/home-pec']);
    }

  }

  public async generateDaysInMonth() {
    registerLocaleData(myLocalePt);

    const daysInMonth = new Date(this.anoCalendario, this.mesCalendario + 1, 0).getDate();
    const parametros = this.SetParametrosCalendario(this.anoCalendario, this.mesCalendario + 1);

    this.spinnerService.show();

    if (parametros.codigoDiretoria == null || parametros.codigoEscola == null && this.filtros.atividadeDiretoria == false) {
      this.toastr.warning("Diretoria e Escola são obrigatórios");
      this.spinnerService.hide();
      return;
    }

    if (this.filtros.atividadeDiretoria !== false) {
      const response = await lastValueFrom(this.relatorioService.getCalendarioOcorrencias(parametros))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.listaDias = response.data;
      this.daysInMonth = [];

      for (let i = 1; i <= daysInMonth; i++) {
        const day = new Date(this.anoCalendario, this.mesCalendario, i);
        const isWeekend = day.getDay() === 0 || day.getDay() === 6;
        const isHoliday = this.isHoliday(day);
        this.daysInMonth.push({ date: day, isWeekend, isHoliday });
      }
    }

    this.spinnerService.hide();
  }

  public async goToPreviousMonth() {
    const date = new Date(this.currentDate);
    date.setMonth(date.getMonth() - 1);

    if (this.mesCalendario == 0) {
      this.anoCalendario -= 1;
      this.mesCalendario = 11;
    } else
      this.mesCalendario -= 1;

    this.currentDate = `${this.anoCalendario}-${this.mesCalendario + 1}-01`;
    await this.generateDaysInMonth();
  }

  public async goToCurrentMonth() {
    const date = new Date(this.currentDate);
    date.setMonth(date.getMonth() + 1);

    if (this.mesCalendario == 11) {
      this.anoCalendario += 1;
      this.mesCalendario = 0;
    } else
      this.mesCalendario += 1;

    this.currentDate = `${this.anoCalendario}-${this.mesCalendario + 1}-01`;
    await this.generateDaysInMonth();
  }

  public isCurrentDay(day: Date): boolean {
    const today = new Date();
    return day.getFullYear() === today.getFullYear() &&
      day.getMonth() === today.getMonth() &&
      day.getDate() === today.getDate();
  }

  public isHoliday(day: Date): boolean {
    // Implemente a lógica para verificar se o dia é um feriado
    // Retorne true se for um feriado, caso contrário, retorne false
    // Por exemplo:
    // return (day.getDate() === 25 && day.getMonth() === 11); // Natal (25 de dezembro)
    return false; // Por enquanto, não consideramos nenhum feriado
  }

  public async onDateChange(event: any) {
    await this.generateDaysInMonth();
  }

  public formatarMes(date: string): string {
    const mes = new Date(date);
    return formatDate(mes, 'LLLL', 'pt');
  }

  public formatarDiaSemana(date: Date): string {
    return formatDate(date, 'EEEE', 'pt-br');
  }

  async getChamadosAtrasados() {

    if (this.userLogado!.modalVisto == true) {
      return;
    }
    this.spinnerService.show();

    const parametros = this.SetParametrosChamados();
    const result = await lastValueFrom(this.chamadoService.getChamadosEnvolvidos(parametros))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.lstChamadosAtrasados = result.data;
    if (this.lstChamadosAtrasados.length > 0) {
      this.showModalNotificacao = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }
    this.spinnerService.hide();

  }

  public async getPlanosContingenciaPendentes() {
    const perfil = this.userLogado?.codigoPerfil;

    if (perfil === Perfil.DiretorEscolar || perfil === Perfil.ViceDiretor) {
      this.spinnerService.show();

      const devolvidos = await lastValueFrom(
        this.planoContingenciaService.getPlanosPorDiretoriaEscolaEStatus(
          this.userLogado?.codigoDiretoria ?? 0,
          this.userLogado?.codigoEscola ?? 0,
          6 // DevolvidoAjustes
        )
      ).catch((err) => this.convivaErrors.handleResultError(err));

      if (!devolvidos?.isSucess) {
        this.toastr.error(devolvidos?.message);
        this.spinnerService.hide();
        return;
      }

      this.lstPlanosContingenciaAjustes = devolvidos.data;

      if (this.lstPlanosContingenciaAjustes.length > 0) {
        this.showModalNotificacao = true;
        this.userLogado!.modalVisto = true;
        this.authService.setUser(this.userLogado!);
      }

      this.spinnerService.hide();
    }
  }


  public async getPlanosMelhoriaPendentes() {
    const perfil = this.userLogado?.codigoPerfil;

    if (perfil === Perfil.DiretorEscolar || perfil === Perfil.ViceDiretor) {
      await this.obterPendenciasPlanoMelhoriaDiretor();

      // devolvido para ajustes (PMCE)
      const devolvidos = await lastValueFrom(
        this.planoMelhoriaService.getPlanoMelhoriaPorEscolaEStatus?.(
          this.userLogado?.codigoEscola ?? 0,
          3 // DevolvidoAjustes
        )
      ).catch((err) => this.convivaErrors.handleResultError(err));

      if (devolvidos?.isSucess) {
        this.lstPlanosMelhoriaAjustes = devolvidos.data;
        if (this.lstPlanosMelhoriaAjustes.length > 0) {
          this.showModalNotificacao = true;
          this.userLogado!.modalVisto = true;
          this.authService.setUser(this.userLogado!);
        }
      }
    }
  }

  private async obterPendenciasPlanoMelhoriaDiretor() {

    let mensagem = '';
    if (!this.dentroDoPeriodoMelhoria) {
      mensagem = 'Fora do período de preenchimento do Plano de Melhoria.';
      return;
    }else{
      mensagem = 'Você deve preencher o PMCE até o dia 30/março.';
    }

    this.spinnerService.show();

    const response = await lastValueFrom(this.planoMelhoriaService.getPlanoMelhoriaPorDiretoriaEEscola(this.userLogado?.codigoDiretoria ?? 0, this.userLogado?.codigoEscola ?? 0)) // status 0 = pendente
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    //Valida se existe um registro para essa escola no ano letivo
    const lstPlanosMelhoriaPendentes = response.data.filter((p: any) => p.anoLetivo == this.anoMelhoria);

    if (lstPlanosMelhoriaPendentes.length == 0) {
      this.showModalNotificacao = true;
      this.mensagemNotificacao.push(mensagem);
      this.FlagSemPlanoMelhoria = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }

    this.spinnerService.hide();
  }

  private async getPeriodoPlanos(){
    try {
      const response = await lastValueFrom(this.ParametroPeriodoService.getAllParametroPeriodo());
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }

      const hoje = new Date();

      const listaContinegencia = response.data.filter((p: any) => new Date(p.dtInicio) <= hoje && new Date(p.dtFim) >= hoje && p.codigoPlano === 1 && p.flAtivo);
      const listaMelhoria = response.data.filter((p: any) => new Date(p.dtInicio) <= hoje && new Date(p.dtFim) >= hoje && p.codigoPlano === 2 && p.flAtivo);

      if(listaContinegencia.length > 0){
        this.dtInicioContingencia = new Date(listaContinegencia[0].dtInicio);
        this.dtFimContingencia = listaContinegencia[0].dtFim;
        this.dentroDoPeriodoContingencia = true;
      }

      if(listaMelhoria.length > 0){
        this.anoMelhoria = new Date(listaMelhoria[0].dtFim).getFullYear();
        this.dentroDoPeriodoMelhoria = true;
      }

    } catch (err) {
      this.convivaErrors.handleResultError(err);
    }
  }

  private async obterPendenciasPlanoContingenciaDiretor() {

    let mensagem = '';
    if (!this.dentroDoPeriodoContingencia) {
      mensagem = 'Fora do período de preenchimento do Plano de Contingência.';
      return;
    }else{
      mensagem = 'Você deve preencher o Plano de Contingência até o dia 30/agosto.';
    }

    if (this.userLogado?.codigoPerfil !== Perfil.DiretorEscolar &&
        this.userLogado?.codigoPerfil !== Perfil.ViceDiretor) {
      return;
    }

    this.spinnerService.show();

    const response = await lastValueFrom(
      this.planoContingenciaService.getPlanos(0, this.userLogado?.codigoDiretoria ?? 0, this.userLogado?.codigoEscola ?? 0)
    ).catch((err) => {
      return this.convivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    const listaContinegencia = response.data.filter((p: any) => new Date(p.dataInclusao) >= new Date(this.dtInicioContingencia) && new Date(p.dataInclusao) <= new Date(this.dtFimContingencia));

    if(listaContinegencia.length == 0) {
      this.showModalNotificacao = true;
      this.FlagSemPlanoContingencia = true;
      this.mensagemNotificacao.push(mensagem);
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }

    this.spinnerService.hide();
  }


  public async getDiretorias() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.lstDiretorias = response.data;
    this.spinnerService.hide();
  }

  public async getEscolas(diretoriaLogada: boolean = false) {
    const codigoDE = this.filtros.codigoDiretoria;
    if (codigoDE != null) {
      this.spinnerService.show();
      const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.lstEscolas = response.data;
      this.spinnerService.hide();
    }
  }

  public async getCalendario() {
    this.mesCalendario = new Date().getMonth();
    this.anoCalendario = new Date().getFullYear();
    this.currentDate = `${this.anoCalendario}-${this.mesCalendario + 1}-01`;
    await this.generateDaysInMonth();
  }

  public zerarTurma() {
    this.turmas = [];
    // this.formHome.get('codigoTurma')?.patchValue(null);
  }

  public onPageChange() {

    if (this.validaSePrecisaBuscarMaisRegistrosNaApi()) return;


    this.PesquisarChamados();
  }

  private validaSePrecisaBuscarMaisRegistrosNaApi(): boolean {
    return this.page * 5 <= this.lstChamados.length
  }

  public async PesquisarChamados() {

    this.submitted = true;
    this.spinnerService.show();

    this.showPesquisa = true;
    const parametros = this.SetParametrosChamados();

    if ((parametros.codigoDiretoria == null || parametros.codigoEscola == null) && parametros.atividadeDiretoria == false) {
      this.toastr.warning("Diretoria e Escola são obrigatórios");
      this.spinnerService.hide();
      return;
    }
    const result = await lastValueFrom(this.chamadoService.getAllChamadosEnvolvidos(parametros))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.lstChamados = result.data;
    this.lstAllChamados = result.data;
    this.totalRegisterCount = result.totalCount!;

    if (this.lstChamados.length == 0) {
      this.alunosRecorrentes = []; // Zerar Alunos Recorrentes
      this.toastr.warning("Não existem chamados para essa pesquisa");
      this.spinnerService.hide();
      return;
    }

    await this.getAlunosRecorrentes(parametros);
  }

  public async getAlunosRecorrentes(parametros: ListarChamados) {
    this.spinnerService.show();

    if (parametros.atividadeDiretoria == false) {
      const result = await lastValueFrom(this.chamadoService.getAlunosRecorrentes(parametros))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.alunosRecorrentes = result.data;
      this.spinnerService.hide();
    }
  }

  public SetParametrosChamados(): ListarChamados {
    const chamado = new ListarChamados();
    chamado.codigoDiretoria = this.filtros.codigoDiretoria;
    chamado.codigoEscola = this.filtros.codigoEscola;
    chamado.codigoTurno = this.filtros.codigoTurno;
    chamado.codigoTurma = this.filtros.codigoTurma;
    chamado.codigoGravidade = this.filtros.codigoGravidade;
    chamado.codigoChamado = this.chamadoFiltrado;
    chamado.ordenacaoCrescente = false;
    chamado.anoAtual = this.filtros.anoAtual;
    chamado.pagina = this.page;
    chamado.atividadeDiretoria = this.userLogado?.apenasDiretoria ?? this.filtros.atividadeDiretoria!;
    return chamado;
  }

  public SetParametrosCalendario(ano: number, mes: number): Consolidado {
    const parametros = new Consolidado();
    parametros.codigoDiretoria = this.filtros.codigoDiretoria;
    parametros.codigoEscola = this.filtros.codigoEscola;
    parametros.ano = ano;
    parametros.mes = mes;
    return parametros;
  }

  public setParametrosEventoNotificacao(): ListarEncaminhados {
    const chamado = new ListarEncaminhados();
    if (this.userLogado != null && this.userLogado.codigoDiretoria != null)
      chamado.codigoDiretoria = this.userLogado.codigoDiretoria;
    if (this.userLogado != null && this.userLogado.codigoEscola != null)
      chamado.codigoEscola = this.userLogado.codigoEscola;
    return chamado;
  }

  public OnInserirOcorrenciaNaoOcorrencia(DataOcorrencia: Date, EstatusDia: number) {
    const dataOco = formatDate(DataOcorrencia, 'yyyy-MM-dd', 'en_US');
    const hoje = formatDate(new Date, 'yyyy-MM-dd', 'en_US');

    const dateOco = new Date();
    // dateOco.setDate(dateOco.getDate() - 7);
    // var hojeMenos7 = formatDate(dateOco,'yyyy-MM-dd','en_US');
    // if(dataOco  < hojeMenos7)
    // {
    //   this.toastr.error('A data da ocorrência deve constar em até 7 dias depois do acontecimento.');
    //   this.spinnerService.hide();
    //   return;
    // }

    if (dataOco > hoje || !(EstatusDia == 4 || EstatusDia == 1))
      this.toastr.warning("Data não valida para uma ação");
    else {
      this.showModalCalendarioOcorrencia = true;
      this.dataOcorrenciaNaoOcorrencia = DataOcorrencia;
    }
  }

  public FecharModalExclusao() {
    this.showModalExcluirChamado = false;
    this.descricaoExclusao = "";
    this.chamadoARemover = 0;
  }

  public FecharModalCalendario() {
    this.showModalCalendarioOcorrencia = false;
    this.descricaoNaoOcorrencia = "";
  }

  public async InserirRegistroNaoOcorrencia() {
    let descricao = this.formHomeNaoOcorrencia.get('dsChamado')!.value;
    if (descricao == null)
      descricao = 'Nao houve chamados para o periodo selecionado';

    await this.getDiretorias();
    await this.getEscolas();

    const dir = this.lstDiretorias.filter(r => r.codigoDiretoria == this.filtros.codigoDiretoria)[0];
    const esc = this.lstEscolas.filter(r => r.codigoEscola == this.filtros.codigoEscola)[0];



    const objetoChamado: NaoOcorrencia = {
      cdGravidade: 0,
      cdCategoria: 13,
      cdSubCategoria: 42,
      dtNaoOcorrencia: formatDate(this.dataOcorrenciaNaoOcorrencia, 'yyyy-MM-dd', 'en_US'),
      cdDiretoria: dir.codigoDiretoria,
      nmDiretoria: dir.nomeDiretoria,
      cdEscola: esc.codigoEscola,
      nmEscola: esc.nomeEscolaSemCodigo,
      dsNaoOcorrencia: descricao,
      cdTurno: 0,
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      cdNaoOcorrencia: 0
    };

    const result = await lastValueFrom(await this.naoOcorrenciaService.setCadastrarNaoOcorrencia(objetoChamado))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Chamado cadastrado com sucesso.');
    this.formNaoOco.dsChamado.setValue(null);

    setTimeout(() => {
      this.submitted = false;
      document.getElementById("btnLimpar")?.click();
    }, 2000);

    this.showModalCadastraNaoOcorrencia = false;
    this.showModalCalendarioOcorrencia = false;
    await this.generateDaysInMonth();
  }

  public InserirOcorrencia() {
    const dt = this.dataOcorrenciaNaoOcorrencia;
    this.router.navigate(['/cadastrar-chamados/', dt]);
  }

  public InserirNaoOcorrencia() {
    this.showModalCadastraNaoOcorrencia = true;
    this.descricaoNaoOcorrencia = "";
  }

  public AbrirModal(codigoChamado: number, codigoEnvolvido: number) {
    this.codigoChamadoSelected = codigoChamado;
    this.codigoEnvolvidoSelected = codigoEnvolvido;
    this.submittedModal = false;
    this.formModal = new FormGroup({
    });
    this.showModal = true;
    this.tituloModal = 'Encaminhamentos';
  }

  public FecharModal() {
    this.showModal = false;
  }

  public async EncaminhamentoPsicologo() {
    this.spinnerService.show();
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado ao Psicólogo.',
      statusChamado: 2,//Encaminhado
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };
    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamento(objetoHistorico))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Aluno Encaminhado ao Psicologo com Sucesso.');
    this.FecharModal();
    this.PesquisarChamados();

  }

  public async EncaminhamentoPolicia() {
    this.spinnerService.show();
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado a Rede protetiva.',
      statusChamado: 2,//Encaminhado
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoPolicia(objetoHistorico))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Aluno Encaminhado a Rede protetiva.');
    this.FecharModal();
    this.PesquisarChamados();

  }

  public async EncaminhamentoSaude() {
    this.spinnerService.show();
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado a Saúde.',
      statusChamado: 3,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoSaude(objetoHistorico))
      .catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Aluno Encaminhado a Saúde com Sucesso.');
    this.FecharModal();
    this.PesquisarChamados();
  }

  public Proximamente() {
    this.toastr.warning("Esta funcionalidade será implementada futuramente");
  }

  public OnVisualizarChamado(id: number) {
    this.router.navigate(['/detalhe/', id]);
  }

  public FormatarDescricaoOcr(dsOcorrencia: string): string {
    if (dsOcorrencia != null) {

      if (dsOcorrencia.length > 80)
        return dsOcorrencia.substring(0, 80) + ' ...';
      else
        return dsOcorrencia;
    }

    return '--';
  }

  public getStatusEnvolvido(status: number | undefined): string | undefined {
    if (status != undefined) {
      const statusViagem = new Map<number, string>([
        [0, 'Não Analisado'],
        [1, 'Encaminhado ao Psicólogo'],
        [2, 'Encaminhado a Rede de Proteção'],
        [3, 'Encaminhado ao Hospital'],
        [4, 'Psicólogo Agendado'],
        [5, 'Atendimento Realizado'],
        [6, 'Concluído'],
      ]);

      return statusViagem.get(status);
    }

    return 'Não Analisado';
  }

  public getCorStatusEnvolvido(status: number | undefined): string | undefined {
    if (status != undefined) {
      const statusViagem = new Map<number, string>([
        [0, 'aberto'],
        [1, 'encaminhado'],
        [2, 'encaminhado'],
        [3, 'encaminhado'],
        [4, 'agendado'],
        [5, 'atendido'],
        [6, 'encerrado'],
      ]);

      return statusViagem.get(status);
    }

    return 'aberto';
  }

  public FiltraChamadosAtuais(event: any) {
    if (event.target?.value) {
      this.filtros.codigoGravidade = event.target.value;

    } else {
      this.filtros.codigoGravidade = undefined;
    }
  }

  public OnChangeCountLetters() {
    const descricao = this.formHomeNaoOcorrencia.get('dsChamado')!.value;
    if (descricao != null)
      this.qtdeCaracteresDescricao = descricao.length;
  }

  public EventTresPontos(event: string) {

    if (event === "Pesquisar") {
      this.PesquisarChamados();
    }

  }

  public FiltrarChamadoId(event: any) {
    if (event.target?.value) {
      this.chamadoFiltrado = event.target.value;
    }
    else
      this.chamadoFiltrado = 0;
  }

  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.spinnerService.show();

    this.setFilters(eventFilter);

    await this.PesquisarChamados();
    await this.getPeriodoPlanos();
    await this.getChamadosAtrasados();
    await this.carregarContagemPendenciasValidacao();
    await this.getPlanosContingenciaPendentes();
    await this.getPlanosMelhoriaPendentes();
    await this.obterPendenciasPlanoContingenciaDiretor();

    this.spinnerService.hide();
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
    this.filtrosCalendarios.set(this.filtros);

  }

  private async carregarContagemPendenciasValidacao() {
    this.contagemPlanoContingenciaValidacao = 0;
    this.contagemPmceValidacao = 0;
    const perfil = this.codigoPerfilAtual;
    if (perfil !== Perfil.PEC && perfil !== Perfil.SupervisorEducacional) {
      return;
    }

    const response = await lastValueFrom(
      this.notificacaoService.getContagemPendenciasValidacao(
        this.userLogado?.codigoDiretoria ?? 0,
        this.userLogado?.codigoEscola ?? 0,
        perfil!
      )
    ).catch((err) => this.convivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      await this.carregarContagemPendenciasValidacaoLegado(perfil!);
      return;
    }

    const d = response.data as {
      planoContingenciaPendentes?: number;
      PlanoContingenciaPendentes?: number;
      pmcePendentes?: number;
      PmcePendentes?: number;
    };
    // PEC não valida mais Plano de Contingência — ignorar contagem de PC
    this.contagemPlanoContingenciaValidacao =
      perfil === Perfil.PEC
        ? 0
        : Number(d?.planoContingenciaPendentes ?? d?.PlanoContingenciaPendentes ?? 0);
    this.contagemPmceValidacao = Number(d?.pmcePendentes ?? d?.PmcePendentes ?? 0);
    // Se o endpoint novo existir mas retornar 0 (ex.: ambiente desatualizado), confere com a consulta legada.
    if (this.contagemPlanoContingenciaValidacao === 0 && this.contagemPmceValidacao === 0) {
      await this.carregarContagemPendenciasValidacaoLegado(perfil!);
      return;
    }

    if (this.contagemPlanoContingenciaValidacao > 0 || this.contagemPmceValidacao > 0) {
      this.showModalNotificacao = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }
  }

  /**
   * Fallback para ambientes sem endpoint novo de contagem:
   * reutiliza as mesmas consultas legadas de pendência.
   */
  private async carregarContagemPendenciasValidacaoLegado(perfil: number) {
    if (perfil === Perfil.SupervisorEducacional) {
      const [pcSup, pmceSup] = await Promise.all([
        lastValueFrom(
          this.planoContingenciaService.getPlanosPorDiretoriaEscolaEStatus(
            this.userLogado?.codigoDiretoria ?? 0,
            0,
            PlanoStatus.AguardandoValidacaoSupervisor
          )
        ).catch((err) => this.convivaErrors.handleResultError(err)),
        lastValueFrom(
          this.planoMelhoriaService.getPlanoMelhoriaPorDiretoriaEStatus?.(
            this.userLogado?.codigoDiretoria ?? 0,
            StatusPlanoMelhoria.AguardandoValidacaoSupervisor
          )
        ).catch((err) => this.convivaErrors.handleResultError(err))
      ]);

      this.lstPlanosContingenciaAguardandoSupervisor = pcSup?.isSucess ? (pcSup.data ?? []) : [];
      this.lstPlanosMelhoriaAguardandoSupervisor = pmceSup?.isSucess ? (pmceSup.data ?? []) : [];
      this.contagemPlanoContingenciaValidacao = this.lstPlanosContingenciaAguardandoSupervisor.length;
      this.contagemPmceValidacao = this.lstPlanosMelhoriaAguardandoSupervisor.length;
    }

    if (perfil === Perfil.PEC) {
      // PEC não valida mais Plano de Contingência — só conta PMCE
      this.lstPlanosContingenciaPendentes = [];
      this.contagemPlanoContingenciaValidacao = 0;

      const pmcePec = await lastValueFrom(
        (this.userLogado?.codigoEscola ?? 0) !== 0
          ? this.planoMelhoriaService.getPlanoMelhoriaPorEscolaEStatus(
              this.userLogado?.codigoEscola ?? 0,
              StatusPlanoMelhoria.AguardandoValidacaoPecConviva
            )
          : this.planoMelhoriaService.getPlanoMelhoriaPorDiretoriaEStatus(
              this.userLogado?.codigoDiretoria ?? 0,
              StatusPlanoMelhoria.AguardandoValidacaoPecConviva
            )
      ).catch((err) => this.convivaErrors.handleResultError(err));

      this.lstPlanosMelhoriaPendentes = pmcePec?.isSucess ? (pmcePec.data ?? []) : [];
      this.contagemPmceValidacao = this.lstPlanosMelhoriaPendentes.length;
    }

    if (this.contagemPlanoContingenciaValidacao > 0 || this.contagemPmceValidacao > 0) {
      this.showModalNotificacao = true;
      this.userLogado!.modalVisto = true;
      this.authService.setUser(this.userLogado!);
    }
  }
}

